import { css } from 'styled-components';
import token from 'styled-token';
import { spaceMixin } from '../spaceMixin';

/** @class PropertyCardSaveAreaMixin */
/** @method */
export var PropertyCardSaveAreaMixin = function PropertyCardSaveAreaMixin(props) {
  return token({
    columnGap: 'PropertyCard.saveArea.gap',
    marginTop: 'PropertyCard.saveArea.marginTop',
    marginRight: 'PropertyCard.saveArea.marginRight'
  }, function (_ref) {
    var columnGap = _ref.columnGap,
      marginTop = _ref.marginTop,
      marginRight = _ref.marginRight;
    return css(["display:grid;grid-auto-flow:column;grid-column-gap:", ";margin-top:calc(-1 * ", ");margin-right:calc(-1 * ", ");"], columnGap ? columnGap + "px" : spaceMixin('sm')(props), marginTop ? marginTop + "px" : spaceMixin('xs')(props), marginRight ? marginRight + "px" : spaceMixin('xs')(props));
  })(props);
};